import { Component } from '@angular/core';

@Component({
    selector: 'app-qbuilt-support',
    imports: [],
    templateUrl: './qbuilt-support.component.html',
    styleUrl: './qbuilt-support.component.scss'
})
export class QbuiltSupportComponent {

}
